(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-ai-solutions-tabs"] && !Shopify.designMode) return;
  try {
    
  class NalaSolTabs extends HTMLElement {
    connectedCallback() {
      this._tabs   = Array.from(this.querySelectorAll('.nala-soltabs__tab'));
      this._panels = Array.from(this.querySelectorAll('.nala-soltabs__panel'));
      this._tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._activate(i));
      });
    }

    _activate(index) {
      this._tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this._panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('nala-sol-tabs')) {
    customElements.define('nala-sol-tabs', NalaSolTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
